<template>
  <header class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="navbar-container">
      <!-- Logo -->
      <router-link to="/" class="navbar-logo">
        <div class="logo-icon">
          <i class="el-icon-s-opportunity"></i>
        </div>
        <div class="logo-text">
          <span class="logo-title">第一届明安图天文前沿论坛</span>
          <span class="logo-subtitle">The First Minggatu Forum on Astronomy Frontier</span>
        </div>
      </router-link>

      <!-- 导航菜单 -->
      <nav class="navbar-menu">
        <router-link 
          v-for="item in menuItems" 
          :key="item.path" 
          :to="item.path" 
          class="menu-item"
          :class="{ 'active': $route.path === item.path }"
        >
          {{ item.name }}
        </router-link>
      </nav>

      <!-- 用户区域 -->
      <div class="navbar-user">
        <template v-if="isLoggedIn">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <el-avatar :size="32" :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
              <span class="user-name">{{ userInfo.realname || userInfo.username }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="user">个人中心</el-dropdown-item>
              <!-- <el-dropdown-item command="registration">参会记录</el-dropdown-item> -->
              <el-dropdown-item command="papers">投稿记录</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <router-link to="/login" class="btn-login">登录</router-link>
          <router-link to="/register" class="btn-register">注册</router-link>
        </template>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="navbar-mobile-btn" @click="showMobileMenu = !showMobileMenu">
        <i :class="showMobileMenu ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <transition name="slide">
      <div v-if="showMobileMenu" class="mobile-menu">
        <router-link 
          v-for="item in menuItems" 
          :key="item.path" 
          :to="item.path" 
          class="mobile-menu-item"
          @click.native="showMobileMenu = false"
        >
          {{ item.name }}
        </router-link>
        <div class="mobile-menu-user" v-if="!isLoggedIn">
          <router-link to="/login" class="btn-login" @click.native="showMobileMenu = false">登录</router-link>
          <router-link to="/register" class="btn-register" @click.native="showMobileMenu = false">注册</router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { getUserInfo, clearUserInfo } from '@/utils'

export default {
  name: 'Navbar',
  data() {
    return {
      isScrolled: false,
      showMobileMenu: false,
      loginState: !!localStorage.getItem('token'),
      menuItems: [
        { name: '首页', path: '/' },
        { name: '大会介绍', path: '/about' },
        { name: '大会日程', path: '/schedule' },
        { name: '摘要提交', path: '/paper' },
        { name: '参会须知', path: '/notice' },
        { name: '照片画廊', path: '/gallery' },
        { name: '联系我们', path: '/contact' },
        { name: '个人中心', path: '/user' }
      ]
    }
  },
  computed: {
    isLoggedIn() {
      return this.loginState
    },
    userInfo() {
      return getUserInfo() || {}
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    // 监听登录状态变化事件
    this.$bus.$on('login-state-change', this.updateLoginState)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    this.$bus.$off('login-state-change', this.updateLoginState)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    updateLoginState() {
      this.loginState = !!localStorage.getItem('token')
    },
    handleCommand(command) {
      switch (command) {
        case 'user':
          this.$router.push('/user/profile')
          break
        case 'registration':
          this.$router.push('/user/registration')
          break
        case 'papers':
          this.$router.push('/user/papers')
          break
        case 'logout':
          this.logout()
          break
      }
    },
    logout() {
      clearUserInfo()
      this.loginState = false
      this.$message.success('退出登录成功')
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
  z-index: 1000;
  transition: all 0.3s ease;

  &.navbar-scrolled {
    background: rgba(26, 35, 126, 0.98);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
  }
}

.navbar-container {
  max-width: 1400px;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;

  .logo-icon {
    width: 45px;
    height: 45px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    i {
      font-size: 24px;
      color: #ffd700;
    }
  }

  .logo-text {
    display: flex;
    flex-direction: column;

    .logo-title {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .logo-subtitle {
      font-size: 11px;
      opacity: 0.8;
      margin-top: 2px;
    }
  }
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 8px;

  .menu-item {
    padding: 8px 16px;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-size: 15px;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
    }

    &.active {
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      font-weight: 500;
    }
  }
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 12px;

  .user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 20px;
    transition: background 0.3s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    .user-name {
      font-size: 14px;
    }
  }

  .btn-login {
    padding: 8px 20px;
    color: #fff;
    text-decoration: none;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    font-size: 14px;
    transition: all 0.3s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: #fff;
    }
  }

  .btn-register {
    padding: 8px 20px;
    color: #1a237e;
    background: linear-gradient(135deg, #ffd700 0%, #ffec8b 100%);
    text-decoration: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
    }
  }
}

.navbar-mobile-btn {
  display: none;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  background: rgba(26, 35, 126, 0.98);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .mobile-menu-item {
    padding: 12px 20px;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-size: 16px;
    border-radius: 8px;
    transition: background 0.3s;

    &:hover, &.router-link-active {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .mobile-menu-user {
    display: flex;
    gap: 12px;
    padding-top: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    margin-top: 10px;
  }
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media screen and (max-width: 1200px) {
  .navbar-menu {
    display: none;
  }

  .navbar-mobile-btn {
    display: flex;
  }

  .navbar-user {
    .btn-login, .btn-register, .user-info {
      display: none;
    }
  }
}
</style>
